import React from 'react';
import Icon, { IconWithCounter } from './Icon';
import { mutedClick } from '../utilities';

const IconsDisabled = ({
  isLogged, poppinIcon, likeIcon, likesCount, commentIcon, commentsCount, shareIcon, reportIcon
}) => (
  <div className="webreader-social-controls">
    <div className="right relative">
      <div className="right o-40">
        <Icon img={poppinIcon} onClick={mutedClick} />
        <IconWithCounter img={likeIcon} count={likesCount} onClick={mutedClick} />
        <IconWithCounter img={commentIcon} count={commentsCount} onClick={mutedClick} />
        <Icon img={shareIcon} onClick={mutedClick} />
        { isLogged && <Icon className="t-pl2-m t-pl1" img={reportIcon} onClick={mutedClick} /> }
      </div>
    </div>
  </div>
);

export default IconsDisabled;
